import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { NotificationToastService } from "../../../../services/notification-toast.service";
import { PatientService } from "../../../../services/patient.service";

@Component({
  selector: "app-patient-referring-physician-control",
  templateUrl: "./patient-referring-physician-control.component.html",
})
export class PatientReferringPhysicianControlComponent implements OnChanges {
  @Input() patientId: number;
  @Input() referringPhysicianId: number;

  enabled = false;
  loading = false;
  saving = false;

  constructor(
    private patientService: PatientService,
    private notificationToastService: NotificationToastService,
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (
      (changes.patientId || changes.referringPhysicianId) &&
      this.patientId != null &&
      this.referringPhysicianId != null
    ) {
      await this.loadEnabled();
    }
  }

  async onEnabledChange(enabled: boolean): Promise<void> {
    if (this.loading || this.saving) {
      return;
    }

    const previousValue = this.enabled;
    this.enabled = enabled;
    this.saving = true;

    try {
      await this.patientService.setPatientReferringPhysician(
        this.patientId,
        this.referringPhysicianId,
        enabled,
      );
    } catch (err) {
      this.enabled = previousValue;
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Médico derivante",
      );
    } finally {
      this.saving = false;
    }
  }

  private async loadEnabled(): Promise<void> {
    this.loading = true;

    try {
      this.enabled = await this.patientService.getPatientReferringAllowed(
        this.patientId,
        this.referringPhysicianId,
      );
    } catch (err) {
      this.enabled = false;
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Médico derivante",
      );
    } finally {
      this.loading = false;
    }
  }
}
